import * as Yup from "yup";
const sliderSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  sortOrder: Yup.number().required("Sort order is required"),
  type: Yup.string().required("Type is required"),
  desktopImage: Yup.mixed().required("Desktop image is required"),
  mobileImage: Yup.mixed().required("Mobile image is required"),
});

const projectSchema = Yup.object().shape({
  name: Yup.string().required("name is required"),
  sortOrder: Yup.number().required("Sort order is required"),
  location: Yup.string().required("Location is required"),
  image: Yup.mixed().required("Image is required"),
});

const catogorySchema = Yup.object().shape({
  name: Yup.string().required("name is required"),
  sortOrder: Yup.number().required("Sort order is required"),
  speed: Yup.string().required("Speed is required"),
  capacity: Yup.string().required("Capacity is required"),
  image: Yup.mixed().required("Image is required"),
});

const projectGallerySchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  sortOrder: Yup.number().required("Sort order is required"),
  image: Yup.mixed().required("Image is required"),
});

const serviceSchema = Yup.object().shape({
  sortOrder: Yup.number().required("Sort order is required"),
  name: Yup.string().required("Name is required"),
  description: Yup.string().required("Description is required"),
  shortDescription: Yup.string().required("shortDescription is required")
});

const clientSchema = Yup.object().shape({
  image: Yup.mixed().required("Image is required"),
  sortOrder: Yup.number().required("Sort order is required"),
});

const brandSchema = Yup.object().shape({
  image: Yup.mixed().required("Image is required"),
  sortOrder: Yup.number().required("Sort order is required"),
});

const milestoneSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  year: Yup.string().required("Year is required"),
  description: Yup.string().required("Description is required"),
  sortOrder: Yup.number().required("Sort order is required"),
});

const faqSchema = Yup.object().shape({
  question: Yup.string().required("Question is required"),
  answer: Yup.string().required("Answer is required"),
  sortOrder: Yup.number().required("Sort order is required"),
});


const changePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string().required("Current Password is required"),
  newPassword: Yup.string().required("New Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

const updateProfileSchema = Yup.object().shape({
  userName: Yup.string().required("Username is required"),
});

const emailTemplateSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  subject: Yup.string().required("Subject is required"),
  content: Yup.string().required("Content is required"),
});

const EmailConfigSchema = Yup.object({
  email: Yup.string().email("Invalid email").required("Email is required"),
  password: Yup.string()
    .min(8, "Minimum 8 characters")
    .required("Password is required"),
  host: Yup.string().required("SMTP host is required"),
  port: Yup.number()
    .typeError("Port must be a number")
    .required("Port is required"),
});

const pageBuilderSchema = Yup.object().shape({
  title: Yup.string()
    .trim()
    .required("Page title is required")
    .min(3, "Title must be at least 3 characters"),
});

const pageSectionSchema = Yup.object().shape({
  sortOrder: Yup.number()
    .typeError("Sort order must be a number")
    .required("Sort order is required")
    .min(1, "Sort order must be at least 1"),
  type: Yup.string().required("Type is required"),
});

const subMenuSchema = Yup.object().shape({
  sortOrder: Yup.number()
    .typeError("Sort order must be a number")
    .required("Sort order is required")
    .min(1, "Sort order must be at least 1"),
  subMenuName: Yup.string().required("Sub Menu Name is required"),
  subMenuType: Yup.string().required("Sub Menu Type is required"),
  subMenuUrl: Yup.string().required("Sub Menu Url is required"),
  menuId: Yup.string().required("Menu Id is required"),
});

const menuSchema = Yup.object().shape({
  sortOrder: Yup.number()
    .typeError("Sort order must be a number")
    .required("Sort order is required")
    .min(1, "Sort order must be at least 1"),
  menuName: Yup.string().required("Menu Name is required"),
  menuType: Yup.string().required("Menu Type is required"),
});

const pageBannerSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  description: Yup.string().required("Description is required"),
  menuId: Yup.string().required("Menu is required"),
});

const SocialMediaSchema = Yup.object().shape({
  sortOrder: Yup.number().required("Sort order is required"),
  name: Yup.string().required("Name is required"),
  url: Yup.string().required("Url is required"),
  icon: Yup.mixed().required("Icon is required"),
});

const keyFeatureSchema = Yup.object().shape({
  sortOrder: Yup.number().required("Sort order is required"),
  name: Yup.string().required("Name is required"),
  icon: Yup.mixed().required("Icon is required"),
});


const teamSchema = Yup.object().shape({
  image: Yup.mixed().required("Image is required"),
  name: Yup.string().required("Name is required"),
  designation: Yup.string().required("Designation is required"),
  sortOrder: Yup.number().required("Sort order is required"),
});

const testimonialSchema = Yup.object().shape({
  sortOrder: Yup.number().required("Sort order is required"),
  name: Yup.string().required("Name is required"),
  description: Yup.string().required("Description is required"),
  rating: Yup.string().required("Rating is required"),
  date: Yup.string().required("Date is required"),
});

const amcplanSchema = Yup.object().shape({
  sortOrder: Yup.number().required("Sort order is required"),
  name: Yup.string().required("Name is required"),
  description: Yup.string().required("Description is required"),
  icon: Yup.mixed().required("Icon is required"),
});

const moduleSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  sortOrder: Yup.number().required("Sort order is required"),
});

const pagewiseFaqSchema = Yup.object({
  sortOrder: Yup.number().min(1).required("Sort order is required"),
  menuId: Yup.string().nullable().required("Menu is required"),
  subMenuId: Yup.string().nullable(),   // optional here, checked in the component
  question: Yup.object({
    englishLanguage: Yup.string().trim().required("English question is required"),
    hindiLanguage: Yup.string().trim().required("Hindi question is required"),
  }),
  answer: Yup.object({
    englishLanguage: Yup.string().trim().required("English answer is required"),
    hindiLanguage: Yup.string().trim().required("Hindi answer is required"),
  }),
  isActive: Yup.boolean(),
});

export {
  sliderSchema,
  changePasswordSchema,
  updateProfileSchema,
  emailTemplateSchema,
  EmailConfigSchema,
  clientSchema,
  milestoneSchema,
  SocialMediaSchema,
  pageSectionSchema,
  pageBuilderSchema,
  subMenuSchema,
  pageBannerSchema,
  menuSchema,
  brandSchema,
  teamSchema,
  faqSchema,
  serviceSchema,
  testimonialSchema,
  amcplanSchema,
  moduleSchema,
  projectSchema,
  projectGallerySchema,
  catogorySchema,
  keyFeatureSchema,
  pagewiseFaqSchema
};
